import { render, staticRenderFns } from "./ImpressumPage.vue?vue&type=template&id=1be7d55c&scoped=true&"
var script = {}
import style0 from "./ImpressumPage.vue?vue&type=style&index=0&id=1be7d55c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be7d55c",
  null
  
)

export default component.exports